import { FilterValue } from "./filters";
import { PropertyStyles, VehicleTab } from "./site";

export enum CardTab {
  INFO = "info",
  PRICE = "price",
}

export enum VehicleSpecialColor {
  BLUE = "blue",
  RED = "red",
  YELLOW = "yellow",
  VIOLET = "violet",
  ORANGE = "orange",
  GOLD = "gold",
  STROKE_BLACK = "stroke_black",
  STROKE_GREEN = "stroke_green",
  STROKE_WHITE = "stroke_white",
}

export enum PriceDisclaimerPosition {
  TOOLTIP = "tooltip",
  BOTTOM = "bottom",
}
export interface VehicleConditionalCardData {
  condition: FilterValue[];
  infoTab: VehicleTab;
  priceTab: VehicleTab;
  priceStyle: PropertyStyles;
  priceField: string;
  priceDisclaimer?: string;
  priceDisclaimerPosition?: PriceDisclaimerPosition;
  defaultTab?: CardTab;
  specialText?: string;
  specialColor?: VehicleSpecialColor;
  contentBelowPrices?: string;
}

export enum SortOrder {
  DESC = "DESC",
  ASC = "ASC",
}

export interface SortOptionValue {
  field?: string;
  order?: SortOrder;
}

export interface SortOption extends SortOptionValue {
  title: string;
  default?: boolean;
}

export enum SearchType {
  GENERIC = "generic",
  VIN_OR_STOCK = "vin_or_stock",
}
